import { EditorView } from '@codemirror/view';
import { syntaxTree } from '@codemirror/language';

import { closeBrackets } from '@codemirror/autocomplete';

const BracketInserter = closeBrackets;

export default BracketInserter;
